import type { LoginActivityItem } from "hooks/useLoginActivity/useLoginActivity.types";
import type {
  ColumnFilterConfig,
  FilterState,
} from "components/common/PaginatedTableView/TableColumnFilter";

export const LOGIN_STATUS_OPTIONS = [
  { value: "SUCCESS", label: "Success" },
  { value: "FAILURE", label: "Failure" },
  { value: "PENDING_MFA", label: "Pending MFA" },
  { value: "MFA_ABANDONED", label: "MFA Abandoned" },
  { value: "LOGOUT", label: "Logout" },
];

export const LOGIN_METHOD_OPTIONS = [
  { value: "PASSWORD", label: "Password" },
  { value: "PASSKEY", label: "Passkey" },
  { value: "SSO", label: "SSO" },
];

export const COLUMN_FILTER_CONFIGS: ColumnFilterConfig[] = [
  {
    columnKey: "status",
    type: "multiselect",
    placeholder: "All Statuses",
    options: LOGIN_STATUS_OPTIONS,
  },
  {
    columnKey: "method",
    type: "multiselect",
    placeholder: "All Methods",
    options: LOGIN_METHOD_OPTIONS,
  },
];

/**
 * Apply filters to login activity rows
 */
export const applyFilters = (
  rows: LoginActivityItem[],
  filters: FilterState
): LoginActivityItem[] => {
  return rows.filter((row) => {
    // Filter by status
    if (filters.status && Array.isArray(filters.status) && filters.status.length > 0) {
      if (!filters.status.includes(row.status)) {
        return false;
      }
    }

    // Filter by method
    if (filters.method && Array.isArray(filters.method) && filters.method.length > 0) {
      if (!filters.method.includes(row.login_method)) {
        return false;
      }
    }

    return true;
  });
};

/**
 * Check if any filters are active
 */
export const hasActiveFilters = (filters: FilterState): boolean => {
  return Object.values(filters).some((value) => {
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    if (typeof value === "string") {
      return value.trim().length > 0;
    }
    return false;
  });
};

/**
 * Get count of active filters
 */
export const getActiveFilterCount = (filters: FilterState): number => {
  return Object.values(filters).reduce((count, value) => {
    if (Array.isArray(value) && value.length > 0) {
      return count + 1;
    }
    if (typeof value === "string" && value.trim().length > 0) {
      return count + 1;
    }
    return count;
  }, 0);
};

/**
 * Clear all filters
 */
export const clearAllFilters = (): FilterState => {
  return {};
};
